package app.components

import app.api.ProjectStepApi
import app.api.ProjectStepApi.StepUpdate
import app.model.ExecutionCondition
import app.model.ProjectWithDependencies
import dev.fritz2.core.*

fun RenderContext.executionConditionInput(
    stepIndex: Int,
    stepExecutionCondition: ExecutionCondition,
    companyProjects: List<ProjectWithDependencies.Company>,
    projectStepApi: ProjectStepApi
) {
    div {
        p("text-sm dark:text-gray-200") { +"Execution Condition:" }
        div("flex gap-2") {
            select("h-8 w-64 bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white") {
                ExecutionCondition.entries.forEach { condition ->
                    option {
                        val conditionName = when (condition) {
                            is ExecutionCondition.Always -> "ALWAYS"
                            is ExecutionCondition.Disabled -> "DISABLED"
                            is ExecutionCondition.PerExecution -> "PER_EXECUTION"
                            is ExecutionCondition.ForCompanies -> "FOR_COMPANIES"
                        }
                        value(conditionName)
                        +conditionName
                        if (ExecutionCondition.getType(stepExecutionCondition) == conditionName) {
                            selected(true)
                        }
                    }
                }
                changes.values() handledBy { conditionName: String ->
                    val condition = when (conditionName) {
                        "ALWAYS" -> ExecutionCondition.Always
                        "DISABLED" -> ExecutionCondition.Disabled
                        "PER_EXECUTION" -> ExecutionCondition.PerExecution
                        "FOR_COMPANIES" -> ExecutionCondition.ForCompanies(companyProjects.map { it.id })
                        else -> throw IllegalStateException("Missing Type here")
                    }
                    projectStepApi.updateStep(
                        Pair(
                            stepIndex,
                            StepUpdate.ExecutionCondition(condition)
                        )
                    )
                }
            }

            if (stepExecutionCondition is ExecutionCondition.ForCompanies) {
                div("flex gap-2") {
                    companyProjects.forEach { company ->
                        div("flex items-center gap-2") {
                            input("accent-blue-500") {
                                type("checkbox")
                                checked(stepExecutionCondition.companyIds.contains(company.companyId))
                                changes handledBy {
                                    val updatedIds = if (stepExecutionCondition.companyIds.contains(company.companyId)) {
                                        stepExecutionCondition.companyIds - company.companyId
                                    } else {
                                        stepExecutionCondition.companyIds + company.companyId
                                    }
                                    projectStepApi.updateStep(
                                        Pair(
                                            stepIndex,
                                            StepUpdate.ExecutionCondition(
                                                ExecutionCondition.ForCompanies(updatedIds)
                                            )
                                        )
                                    )
                                }
                            }
                            span("dark:text-gray-200") {
                                +company.name
                            }
                        }
                    }
                }
            }
        }
    }
}